import React from 'react';
import './css/Home.css'; // Ensure the correct path is set


const Modal = ({ children, isOpen, onClose, tabs, activeTab, setActiveTab }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="modal-close-button">X</button>
        {tabs && (
          <div className="modal-tabs">
            {tabs.map((tab) => (
              <button 
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={activeTab === tab.id ? 'active' : ''}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
